import { uploadPocketBalanceData } from '../../_services/pocket_balance.service';

export const uploadPocketBalanceDataEvent = async (bytes, extension, type) => {
    let res = await uploadPocketBalanceData(bytes, extension, type);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}